import TRANSLATION_ACCESSIBILITY_PL from './accessibility/translation';
import TRANSLATION_BOOKING_PL from './booking/translation';
import TRANSLATION_EVENTS_PL from './events/translation';
import TRANSLATION_EXPERIENCES_PL from './experiences/translation';
import TRANSLATION_FORM_PL from './form/translation';
import TRANSLATION_LANDING_PAGES_PL from './landingPages/translation';
import TRANSLATION_RESERVE_PL from './reserve/translation';
import TRANSLATION_SIGNIN_PL from './signin/translation';
import TRANSLATION_DATES_PL from './weekdays/translation';

export default {
  ...TRANSLATION_ACCESSIBILITY_PL,
  ...TRANSLATION_BOOKING_PL,
  ...TRANSLATION_DATES_PL,
  ...TRANSLATION_EVENTS_PL,
  ...TRANSLATION_EXPERIENCES_PL,
  ...TRANSLATION_FORM_PL,
  ...TRANSLATION_LANDING_PAGES_PL,
  ...TRANSLATION_RESERVE_PL,
  ...TRANSLATION_SIGNIN_PL,
};
